import React, { createContext, useContext, useRef, ReactNode } from 'react';

interface ModalContextValue {
  isModalOpenRef: React.MutableRefObject<boolean>;
  pendingCaseRequestRefreshRef: React.MutableRefObject<boolean>;
  onModalOpen: () => void;
  onModalClose: () => void;
}

const ModalContext = createContext<ModalContextValue | undefined>(undefined);

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const isModalOpenRef = useRef(false);
  const pendingCaseRequestRefreshRef = useRef(false);

  const onModalOpen = () => {
    isModalOpenRef.current = true;
  };

  const onModalClose = () => {
    isModalOpenRef.current = false;
  };

  const value: ModalContextValue = {
    isModalOpenRef,
    pendingCaseRequestRefreshRef,
    onModalOpen,
    onModalClose,
  };

  return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>;
};
